import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Moment } from 'moment';
import moment from 'moment';

export const ofMinorAge = (): ValidatorFn => {
    return (control: AbstractControl): { [key: string]: boolean } => {
        const v: Moment = control.value;

        if (!v) {
            return null;
        }

        const today = moment().subtract(18, 'years');

        return today.isBefore(v) ? null : { ofMinorAge: true };
    };
};
